export const USAGE_PRICING_OPTIONS = {
  TIERS: 'Tiered',
  VOLUME: 'Volume',
  PER_UNIT: 'Per Unit',
  REVENUE_SHARE: 'Revenue Share',
  TIERED_SUBSCRIPTION: 'Tiered Subscription',
} as const;

export type UsagePricingOption = (typeof USAGE_PRICING_OPTIONS)[keyof typeof USAGE_PRICING_OPTIONS];
